class SliderReviews extends HTMLElement {
  constructor() {
    super();

    this.sliderElement = this.querySelector("[data-slider-main]");
    this.sliderNumber = Number(this.sliderElement.dataset.sliderNumber);
    this.enableArrow = this.dataset.enableArrows === 'true' ? true : false;
    this.enableLoops = this.dataset.loopSlides === 'true' ? true : false;
  }

  connectedCallback() { 
    if (this.sliderElement) {
      const slider = new Splide(this.sliderElement, {
        pagination: false,
        arrows: this.enableArrow,
        gap: "29px",
        autoWidth: true,
        padding: this.sliderNumber == 2 ? 50 : 20,         
        type: this.enableLoops ? 'loop' : 'slide',
        breakpoints: {
          1439: {
            gap: "20px"
          },
          989: {
            gap: "15px"
          },
          749: {
            gap: "10px"
          }
        },
      });
      slider.on('overflow', function (isOverflow) {
        slider.options = {
          drag: isOverflow,
          type: isOverflow ? 'loop' : 'slide',
          clones: isOverflow ? undefined : 0,
        }
      });
        
      slider.mount();      
    }
  }
}

customElements.define("slider-reviews", SliderReviews);
